import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/");
    } catch {
      setError("Falscher Benutzername oder Passwort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>🌬️</div>
        <h1 style={styles.title}>WindMess</h1>
        <p style={styles.subtitle}>Unterer Rheinweg 48-52, 4057 Basel | Kull Solutions GmbH</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            style={styles.input}
            type="text"
            placeholder="Benutzername"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoFocus
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && <div style={styles.error}>{error}</div>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? "Anmelden…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
  },
  card: {
    background: "#1e293b",
    borderRadius: 16,
    padding: "40px 48px",
    width: 360,
    textAlign: "center",
    boxShadow: "0 25px 50px rgba(0,0,0,0.5)",
  },
  logo: { fontSize: 48, marginBottom: 8 },
  title: { color: "#f1f5f9", fontSize: 28, fontWeight: 700, margin: "0 0 4px" },
  subtitle: { color: "#64748b", fontSize: 13, marginBottom: 32 },
  form: { display: "flex", flexDirection: "column", gap: 12 },
  input: {
    background: "#0f172a", border: "1px solid #334155", borderRadius: 8,
    color: "#f1f5f9", padding: "12px 16px", fontSize: 15, outline: "none",
  },
  error: {
    background: "#450a0a", color: "#fca5a5", borderRadius: 8,
    padding: "10px 14px", fontSize: 13,
  },
  button: {
    background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
    color: "#fff", border: "none", borderRadius: 8,
    padding: "13px", fontSize: 15, fontWeight: 600,
    cursor: "pointer", marginTop: 4,
  },
};
